import React, { useState, useMemo, useEffect } from "react";
import Select from "react-select";
import countryList from "react-select-country-list";
import "./myReactSelect.css";

export default function CountrySelector(props) {
  const options = useMemo(() => countryList().getData(), []);

  // Find Pakistan option
  const defaultCountry =
    options.find((item) => item.label === "Pakistan") || null;
  //.....props.countryId that have a country id

  const [value, setValue] = useState(
    props.countryId
      ? options.find((item) => item.value === props.countryId)
      : defaultCountry
  );
  const [disable, setDisable] = useState(props.disabler);
  useEffect(() => {
    if (props.countryId) {
      setValue(props.countryId);
      setDisable(props.disabler);
    }
  }, [props.countryId, props.disabler]);

  const changeHandler = (value) => {
    props.countrySelect(value);
    setValue(value);
  };

  return (
    <Select
      options={options}
      placeholder={
        localStorage.getItem("comp_lang") == "ur"
          ? "--منتخب کریں--"
          : localStorage.getItem("comp_lang") == "ar"
          ? "--يختار--"
          : "--select--"
      }
      value={value}
      onChange={changeHandler}
      isDisabled={disable}
      isClearable
    />
  );
}

// export default CountrySelector;
